import { Box, Button, Divider, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { RobotoTypo } from '../../../utils/Typographies';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ReactComponent as RightArrow } from "../../../assets/StudyingAboard/RightSideArrow.svg";
import ConsultationCard from './ConsultationCard';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

function ConsultationSingle({ activity, setActivity }) {
  const language = useSelector((state) => state.language.language);
  const [activitiesList, setActivitiesList] = useState([]);
  const { courseId } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
 
  
  // const { activity } = state;
  console.log(activity, 'activity');


  const getCourseDetails = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/get-consultation/${courseId}`
      );
      console.log(response, 'resp');
      if (response.data.success) {
        setActivity(response.data.data);
      }
    } catch (error) {
      console.log("Error fetching course details", error);
    }
  };

  useEffect(() => {
    getCourseDetails();
  }, [courseId]);

   const fetchActivitiy = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/get-consultations-by-category/${activity?.category}`
        );
        
        if (response.data.success) {
          const filteredActivities = response.data.data.filter((act) => act._id !== courseId);
          setActivitiesList(filteredActivities);
        }
      } catch (error) {
        console.log("Error fetching activities", error);
      }
    }
  
    useEffect(() => {
      fetchActivitiy();
    }, [activity]);

     const handleRegisterNow = () => {
        const studentToken = localStorage.getItem("student_token");
        const roleName = localStorage.getItem("role_name");
    
        if (studentToken && roleName == "Student") {
            navigate(`/consultation/${activity.category}/${activity._id}`, { state: { activity } })
        } else {
            navigate("/login", {
              state: {
                from: "consultation",
                routes: `/consultation/${activity._id}`,
              },
            });
        }
      };

   const youtubeUrlToEmbed = (url) => {
  if (!url) return "";

  try {
    const parsedUrl = new URL(url);

    // https://www.youtube.com/watch?v=VIDEO_ID
    if (parsedUrl.hostname.includes("youtube.com")) {
      const videoId = parsedUrl.searchParams.get("v");
      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}`;
      }
    }

    // https://youtu.be/VIDEO_ID
    if (parsedUrl.hostname.includes("youtu.be")) {
      const videoId = parsedUrl.pathname.replace("/", "");
      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}`;
      }
    }

    return "";
  } catch (error) {
    return "";
  }
};

  return (
    <>
    <Box sx={{padding : '5% 8%'}}>

        <Box>
          <RobotoTypo style={{ fontSize : '28px', color : '#003B5C', fontWeight : 700 }}>{activity?.title?.[language]}</RobotoTypo>
          <RobotoTypo style={{marginTop : '18px', color : '#242424', fontWeight : 400, fontSize : '20px'}}>{activity?.description?.[language]}</RobotoTypo>
        </Box>

        {activity && activity?.tags?.[language] && (
<Box sx={{mt : '50px', display : 'flex', gap : '10px', flexWrap : 'wrap'}}>
                  
                    {activity?.tags?.[language].map((tag, i) => (
                        <RobotoTypo key={i} style={{padding : '6px 18px', border : '2px solid #177D84', color : '#177D84', borderRadius : '40px', fontSize : '20px'}}>{tag}</RobotoTypo>
                    ))}
                    
                </Box>
        )}
        

                <Divider sx={{marginTop : '100px', borderBottomWidth : '2px', borderColor : '#E0E0E0',mb: '100px'}}/>

                <Box>
          {activity?.images?.map((img, index) => (
            <>
            <Box
              component={"img"}
              key={index}
              src={`${process.env.REACT_APP_FILE_URL1}${img.filePath}`}
              alt={`Activity Image ${index + 1}`}
              style={{ width: '100%', borderRadius: '8px', marginBottom: '100px' }}
              sx={{ height : {xs : '100%', sm : '400px'}, objectFit : 'cover'}}
            />
            <Divider sx={{ borderBottomWidth : '2px', borderColor : '#E0E0E0', mb : '100px'}}/>
            </>
          ))}
        </Box>

        <Box>
  {activity?.videoUrls?.map((videoUrl, index) => {
    const embedUrl = youtubeUrlToEmbed(videoUrl);

    if (!embedUrl) return null;

    return (
      <Box key={index} sx={{ mb: "100px" }}>
        <iframe
          width="100%"
          height="500"
          src={embedUrl}
          title={`YouTube video ${index}`}
          frameBorder="0"
          style={{ borderRadius: "8px" }}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </Box>
    );
  })}
</Box>

        <Box style={{mt : '100px'}}>
<Box sx={{mt : '16px', display : 'flex', justifyContent : 'center', alignItems : 'center'}}>
            <Button endIcon={<RightArrow />}
             variant="contained"
             style={{backgroundColor : '#177D84', padding : '8px 25px', fontSize : '20px', fontWeight : 700, color : 'white', borderRadius : "40px"}}
                      onClick={() => handleRegisterNow()}
                      sx={{
                        backgroundColor: "#177D84",
                        // padding: "14px",
                        ":hover": {
                          bgcolor: "#177D84",
                        },
                        color : 'white',
                        
                      }}
                    >
                      {" "}
                      {t("Register Now")}
                    </Button>
        </Box>
        </Box>
    </Box>
    
    <Box sx={{backgroundColor : "#F7F7F7", padding : '5% 8%'}}>

      <Box sx={{display : 'flex', justifyContent : 'center'}}>
        <Box sx={{display : 'flex', justifyContent : 'center',backgroundColor : "#183265", borderRadius : '50px'}}>
            <RobotoTypo style={{fontSize : '26px', fontWeight : 700,  padding : '8px 25px',  color : 'white'}}>{t("Similar Sessions")}</RobotoTypo>
        </Box>
        
      </Box>

      <Box>
              <Box sx={{display : 'flex', flexWrap : 'wrap', gap : '60px', justifyContent : 'flex-start', marginTop : '40px'}}>
                {activitiesList.map((activity, index) => (
                  <ConsultationCard 
                  key={index} 
                  activity={activity}
                  image={activity.bannerImage} 
                  title={activity.title} 
                  description={activity.description} 
                  Date={new Date(activity.date).toLocaleDateString()} 
                  tags={activity?.tags?.[language]}
                  />  
                ))}
              </Box>
            </Box>

    </Box>
    </>
  )
}

export default ConsultationSingle;